import React from 'react';
import Header from '../component/layout/Header';
import Hero from '../component/about/Hero';
import Growth from '../component/about/Growth';
import Values from '../component/about/Values';
// import Team from '../component/about/Team';
// import Testimonials from '../component/about/Testimonials';
// import Locations from '../component/about/Locations';
import Funded from '../component/about/Funded';
import Footer from '../component/layout/Footer';

export default function About() {
  return (
    <div>
      <Header />
      <Hero />
      <Growth />
      <Values />
      {/* <Team /> */}
      {/* <Testimonials /> */}
      {/* <Locations /> */}
      <Funded />
      <Footer />
    </div>
  )
}